<template>
  <div class="box">
    <div class="imgOne" v-if="flag==1">
      <img src="https://file.s5yun.com/resources/appico/16152786681330800_（企业）甘肃国投集团公司建设方案_02.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152786741158149_（企业）甘肃国投集团公司建设方案_04.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152786811858548_（企业）甘肃国投集团公司建设方案_07.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152786925144298_（企业）甘肃国投集团公司建设方案_13.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152786987299963_（企业）甘肃国投集团公司建设方案_15.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152787040631830_（企业）甘肃国投集团公司建设方案_16.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152787139530942_（企业）甘肃国投集团公司建设方案_20.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152787198531152_（企业）甘肃国投集团公司建设方案_21.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152787257949761_（企业）甘肃国投集团公司建设方案_23.png" alt="#">
    </div>
    <div class="imgOne" v-if="flag==2">
      <img src="https://file.s5yun.com/resources/appico/16152782475268825_tu1.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152782524146856_tu2.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152782572421241_tu3.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152782618113101_tu4.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152782662391818_tu5.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152782704975604_tu6.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152782745927267_tu7.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152782787184968_tu8.png" alt="#">
    </div>
    <div class="imgOne" v-if="flag==3">
      <img src="https://file.s5yun.com/resources/appico/16152772978996696_tu01.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152775599212800_tu02.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152775660783423_tu03.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152775709640200_tu04.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152775754255085_tu05.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152775795583502_tu06.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152776829409951_（政府）钉钉数字“新基建”建设方案_08.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152776881476544_（政府）钉钉数字“新基建”建设方案_09.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152776967431676_（政府）钉钉数字“新基建”建设方案_10.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152777020723717_（政府）钉钉数字“新基建”建设方案_11.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152777076266123_（政府）钉钉数字“新基建”建设方案_12.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152778151081532_（政府）钉钉数字“新基建”建设方案_13.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152778248194206_（政府）钉钉数字“新基建”建设方案_15.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152778354022148_（政府）钉钉数字“新基建”建设方案_16.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152778451732870_（政府）钉钉数字“新基建”建设方案_17.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152778528524722_（政府）钉钉数字“新基建”建设方案_18.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152778614198273_（政府）钉钉数字“新基建”建设方案_19.png" alt="#">
      <img src="https://file.s5yun.com/resources/appico/16152778682671195_（政府）钉钉数字“新基建”建设方案_20.png" alt="#">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      flag: 0
    }
  },
  created () {
    this.flag = Number(this.$route.query.id)
  },
  methods: {
  },
  mounted () {
    document.title = '速云官网'
  }
}
</script>

<style lang="less" scoped>
  .box{
    width: 70%;
    margin: 0 auto;
    img{
      width: 100%;
      vertical-align: middle;
    }
  }
</style>
